<template>
	<layout-visitor class="is-white">
		<slot />
	</layout-visitor>
</template>

<script>
export default {
	name: 'VisitorWhite',
};
</script>

<style lang="scss" scoped>
.wrapper.is-white {
	background-color: $color-white;
}

/deep/ .wrapper-shape {
	display: none;
}
</style>
